export default __webpack_public_path__ + "static/media/1.810956c1.jpg";